import {
  CreateMachineForMachineOnboardingPayload,
  postCreateMachineForMachineOnboarding,
} from "@src/cloud-connect/api/client-configuration/post-create-machine-for-machine-onboarding";
import { Machine } from "@src/cloud-connect/api/client-configuration/get-machine-by-id";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface CreateMachineForMachineOnboardingResult {
  success: boolean;
  data?: Machine;
  error?: string;
  errorData?: unknown;
  status?: number;
}

export const createMachineForMachineOnboardingUseCase = async (
  payload: CreateMachineForMachineOnboardingPayload,
): Promise<CreateMachineForMachineOnboardingResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await postCreateMachineForMachineOnboarding(
      namespace,
      payload,
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    const parsed = parseAxiosApiError(error, "Failed to create machine.");

    return {
      success: false,
      error: parsed.message,
      errorData: parsed.data,
      status: parsed.status,
    };
  }
};
